<template>
  <div :class="$style.container">
    <StatusIcon
      :item="item"
      :type="statusIconTypes.systemUser"
    />
    <FormattedDate
      v-if="item.activated"
      :class="$style.text"
      :item="item"
      :type="formattedDateTypes.userPasswordExpiry"
    />
    <p
      v-else
      :class="$style.text"
    >
      Password pending
    </p>
  </div>
</template>

<script>
import { BodyComponentConsts } from 'client/util/Constants';
import FormattedDate from 'client/components/ItemTable/BodyComponents/FormattedDate.vue';
import StatusIcon from 'client/components/ItemTable/BodyComponents/StatusIcon.vue';

const { formattedDateTypes, statusIconTypes } = BodyComponentConsts;

export default {
  name: 'PasswordStatusIcon',

  components: {
    FormattedDate,
    StatusIcon,
  },

  props: {
    item: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      formattedDateTypes,
      statusIconTypes,
    };
  },
};
</script>

<style module>
.container {
  display: flex;
}

.text {
  font-weight: 300;
  margin: 1px 0 0 0.5em !important;
}
</style>
